import React, { useId } from "react";
import { clsx } from "clsx";
import OffScreen from "./OffScreen.tsx";

interface SelectProps extends React.ComponentPropsWithRef<"select"> {
  label: React.ReactNode;
  hideLabel?: boolean;
  fitContent?: boolean;
  shape?: "rectangle" | "pill";
}

const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  function TextInput(
    {
      label,
      children,
      className,
      shape = "rectangle",
      hideLabel,
      fitContent,
      ...rest
    },
    ref
  ) {
    const selectId = useId();

    const labelElement = <label htmlFor={selectId}>{label}</label>;

    return (
      <div
        className={clsx(
          `vst-select-${shape}`,
          fitContent && "vst-select-option-fit-content",
          className
        )}
      >
        {hideLabel ? <OffScreen>{labelElement}</OffScreen> : labelElement}
        <select {...rest} ref={ref} id={selectId}>
          {children}
        </select>
      </div>
    );
  }
);

export default Select;
